import styled, { css } from 'styled-components';
import { Container as WaveBannerContainer } from 'Modules/HeroBanner/MakeWaves/MakeWaves.styled';

export const Container = styled(WaveBannerContainer)`
    ${({ theme }) => css`
        & {
            padding-bottom: 0;
        }

        @media ${theme.breakpoints.medium.media} {
            padding-bottom: 2rem;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        height: 10rem;
        max-width: 75rem;
        margin-top: 2rem;

        @media ${theme.breakpoints.medium.media} {
            position: absolute;
            width: 50%;
            top: 0;
            bottom: 0;
            right: 0;
            height: auto;
            margin-top: 0;
        }
    `}
`;
